import { RadioButtonGroup, Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './OffersPicker.css';
import { IOfferSchema } from '../../repositories/chats/entities/get_my_offers_for_selection/OfferSchema';
import { ETabType } from '../../repositories/chats/v1/get-my-offers-for-selection-desktop';
import { ERequestApiStatus } from '../../types/appState';
import { OffersEmptyState } from '../OffersEmptyState';
import { OffersPickerSelectionItem } from '../OffersPickerSelectionItem';

const RADIO_OPTIONS = [
  {
    label: 'Сдаю',
    value: ETabType.Rent,
  },
  {
    label: 'Продаю',
    value: ETabType.Sale,
  },
];

interface IProps {
  currentType: string;
  isReachedLimit: boolean;
  selectedIds: Array<number>;
  offersList: IOfferSchema[];
  offersSelectionStatus: ERequestApiStatus;
  pickerAreaRef: React.RefObject<HTMLDivElement>;
  targetObserverElementRef: React.RefObject<HTMLDivElement>;
  upperEmptyBlockHeight: number;
  startIndex: number;
  endIndex: number;
  downEmptyBlockHeight: number;
  handleSlicedList: () => void;
  handleOffersLoad: () => void;
  onSelect(value: IOfferSchema): void;
  handleTypeChange(_: never, value: string): void;
}

export const OffersPicker = ({
  currentType,
  selectedIds,
  offersList,
  offersSelectionStatus,
  isReachedLimit,
  pickerAreaRef,
  upperEmptyBlockHeight,
  startIndex,
  endIndex,
  downEmptyBlockHeight,
  targetObserverElementRef,
  handleSlicedList,
  onSelect,
  handleOffersLoad,
  handleTypeChange,
}: IProps) => {
  const isLoading = offersSelectionStatus === ERequestApiStatus.Pending;

  return (
    <div data-name="OfferPicker" className={style['picker']}>
      <div className={style['radio']}>
        <RadioButtonGroup options={RADIO_OPTIONS} value={currentType} onChange={handleTypeChange} />
      </div>
      <div ref={pickerAreaRef} className={style['offers']} onScroll={handleSlicedList}>
        <div style={{ height: `${upperEmptyBlockHeight}px` }} />
        {offersList.slice(startIndex, endIndex + 1).map((offer, index) => (
          <OffersPickerSelectionItem
            key={offer.realtyOfferId}
            offer={offer}
            isFirstInList={!index}
            isReachedLimit={isReachedLimit}
            selectedIds={selectedIds}
            onSelect={onSelect}
          />
        ))}
        {isLoading && (
          <div className={style['loader']}>
            <Spinner size={16} />
          </div>
        )}
        <div style={{ height: `${downEmptyBlockHeight}px` }} />
        <div style={{ height: 2 }} ref={targetObserverElementRef} />
      </div>
      {!offersList.length && !isLoading && (
        <OffersEmptyState onLoad={handleOffersLoad} isWithError={offersSelectionStatus === ERequestApiStatus.Failed} />
      )}
    </div>
  );
};
